import actionCategoryFilter from 'app/filters/actionCategory'

export default class ActionCategory {

    // Office
    static NO_DATA = 'NO_DATA';
    static OFFLINE = 'OFFLINE';
    static MOISTURE = 'MOISTURE';
    static DEVIATION_EXCEEDED = 'DEVIATION_EXCEEDED';
    static STRANGE_PROGRESS = 'STRANGE_PROGRESS';
    static SMALL_MAINTENANCE = 'SMALL_MAINTENANCE';
    static PROVIDER_MALFUNCTION = 'PROVIDER_MALFUNCTION';

    // Field
    static RESET = 'RESET';
    static BATTERY = 'BATTERY';
    static BOARD_CHANGE = 'BOARD_CHANGE';
    static REPLACE_LOGGER = 'REPLACE_LOGGER';
    static PHYSICAL_DAMAGE = 'PHYSICAL_DAMAGE';
    static NOT_ACCESSIBLE = 'NOT_ACCESSIBLE';
    static CONTROL_MEASUREMENT = 'CONTROL_MEASUREMENT';
    static BACK_ONLINE = 'BACK_ONLINE';

    // Universal
    static OTHER = 'OTHER';

    // Legacy
    static LOGGER_FUNCTIONAL = 'LOGGER_FUNCTIONAL';
    static SENSOR_DIRTY = 'SENSOR_DIRTY';

    static officeOptions(){

        return [
            { value: ActionCategory.NO_DATA, label: actionCategoryFilter(ActionCategory.NO_DATA) },
            { value: ActionCategory.OFFLINE, label: actionCategoryFilter(ActionCategory.OFFLINE) },
            { value: ActionCategory.MOISTURE, label: actionCategoryFilter(ActionCategory.MOISTURE) },
            { value: ActionCategory.DEVIATION_EXCEEDED, label: actionCategoryFilter(ActionCategory.DEVIATION_EXCEEDED) },
            { value: ActionCategory.STRANGE_PROGRESS, label: actionCategoryFilter(ActionCategory.STRANGE_PROGRESS) },
            { value: ActionCategory.SMALL_MAINTENANCE, label: actionCategoryFilter(ActionCategory.SMALL_MAINTENANCE) },
            { value: ActionCategory.PROVIDER_MALFUNCTION, label: actionCategoryFilter(ActionCategory.PROVIDER_MALFUNCTION) },
            { value: ActionCategory.OTHER, label: actionCategoryFilter(ActionCategory.OTHER) }
        ];
    }

    static fieldOptions(){

        return [
            { value: ActionCategory.RESET, label: actionCategoryFilter(ActionCategory.RESET) },
            { value: ActionCategory.BATTERY, label: actionCategoryFilter(ActionCategory.BATTERY) },
            { value: ActionCategory.BOARD_CHANGE, label: actionCategoryFilter(ActionCategory.BOARD_CHANGE) },
            { value: ActionCategory.REPLACE_LOGGER, label: actionCategoryFilter(ActionCategory.REPLACE_LOGGER) },
            { value: ActionCategory.PHYSICAL_DAMAGE, label: actionCategoryFilter(ActionCategory.PHYSICAL_DAMAGE) },
            { value: ActionCategory.NOT_ACCESSIBLE, label: actionCategoryFilter(ActionCategory.NOT_ACCESSIBLE) },
            { value: ActionCategory.CONTROL_MEASUREMENT, label: actionCategoryFilter(ActionCategory.CONTROL_MEASUREMENT) },
            { value: ActionCategory.BACK_ONLINE, label: actionCategoryFilter(ActionCategory.BACK_ONLINE) },
            { value: ActionCategory.OTHER, label: actionCategoryFilter(ActionCategory.OTHER) }
        ];
    }
}